"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = highlightDisplayText;
exports.dehighlightDisplayText = dehighlightDisplayText;

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/map"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/reduce"));

/* Ported from https://outlookweb.visualstudio.com/Outlook%20Web */
var START_MATCH_DELIMITER = String.fromCharCode(0xe000); // The server uses this char to mark start of highlighting.

var END_MATCH_DELIMITER = String.fromCharCode(0xe001); // The server uses this char to mark end of highlighting.

var SPACE_REGEX = /\s/g;
var NONBREAKING_SPACE_CHAR = String.fromCharCode(160);
var START_MATCH_DELIMITER_REGEXP = new RegExp(START_MATCH_DELIMITER, 'g');
var END_MATCH_DELIMITER_REGEXP = new RegExp(END_MATCH_DELIMITER, 'g');

function highlightDisplayText(displayText) {
  // Split the string into substrings that have exactly one highlighted area
  var highlightSubstrings = displayText.replace(SPACE_REGEX, NONBREAKING_SPACE_CHAR).split(START_MATCH_DELIMITER); // Build an array of highlighted and un-highlighted regions

  var highlightTextRegions = (0, _reduce.default)(highlightSubstrings).call(highlightSubstrings, function (regions, current) {
    var _context;

    return (0, _concat.default)(regions).call(regions, // Split the current substring into a highlighted region and an un-highlighted region
    (0, _map.default)(_context = current.split(END_MATCH_DELIMITER)).call(_context, function (substr, i, sections) {
      return {
        // if there are two sections, then the first one came before
        // the highlight end mark, and the second came after. If there
        // is only one section, then there was no highlighting to begin with.
        isHighlighted: i === 0 && sections.length === 2,
        text: substr
      };
    }));
  }, []);
  return highlightTextRegions;
}

function dehighlightDisplayText(displayText) {
  return displayText.replace(START_MATCH_DELIMITER_REGEXP, '').replace(END_MATCH_DELIMITER_REGEXP, '');
}